import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import mainFeature from '../../assets/images/fourposition/feature1.jpeg';
import feature2 from "../../assets/images/fourposition/feature2.jpeg";
import feature3 from "../../assets/images/fourposition/feature3.jpeg";
import feature4 from "../../assets/images/fourposition/feature4.jpeg";
import "./newgraduate.css";

class HeadQuarterGraduate extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>採用情報 | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div className='container-box banner-container graduate_banner'>
                    <div className='overlay'></div>
                    <div className='row'>
                        <div className='col'>
                            <h1>採用情報</h1>
                            <h3>RECRUITMENT</h3>
                        </div>
                    </div>
                </div>
                <div className="container-box">
                    <div className="row row-title">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-sm-8 col-lg-6 col-xl-5">
                            <h1 className="text-orange">新卒採用【本社】</h1>
                            <h5>NEW GRADUATES RECRUITMENT【MAIN OFFICE】</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                            <img src={mainFeature} alt="feature" className="img-fluid" />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6 main_feature_text p-4">
                            <h4>システム開発のすべてを手掛けられる魅力</h4><br />
                            <p>お客様から「こんなシステムを実現したい」との要望を聞き、システムの企画・仕様の提案から開発・保守メンテナンスまで一貫して行っています。
                                自社開発の環境が整っており、本社にいる場合でも直接お客様から電話が
                                かかってきて一緒に要件をつめ、課題を解決していくため、
                                自らの手で開発したシステムという実感を強く持てます。 無事稼働しお客様から「ありがとう」と感謝の言葉をいただけた時の喜びは格別です。</p>
                        </div>
                    </div>
                    <div className="row sub_features">
                        <div className="col-sm-12 col-md-12 col-lg-4 p-3">
                            <div className="card">
                                <div className="card-img">
                                    <img src={feature2} alt="team feature" className="img-fluid card-img-top" />
                                </div>
                                <div className="card-body">
                                    <p className="feature_description card-text">何らかのシステム開発経験がある方で開発が好き、自分の仕事により、たくさんの人々を喜ばせたい方はぜひ！</p>
                                </div>
                            </div>

                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-4 p-3">
                            <div className="card">
                                <div className="card-img">
                                    <img src={feature3} alt="time feature" className="img-fluid card-img-top" />
                                </div>
                                <div className="card-body">
                                    <p className="feature_description card-text">残業月12時間程度、プロジェクトチーム毎に早く帰る工夫をしています。<br />
                                        9:00～18:00（実働：8時間）</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-4 p-3">
                            <div className="card">
                                <div className="card-img">
                                    <img src={feature4} alt="leadership feature" className="card-img-top" />
                                </div>
                                <div className="card-body">
                                    <p className="feature_description card-text">プロジェクトマネジメントやリーダーシップなどのヒューマンスキルに関する研修も積極的に受講することができます。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-box mb-5">
                    <div className="row row-title">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-md-8 col-lg-6 col-xl-4">
                            <h1 className="text-blue">募集詳細</h1>
                            <h5>RECRUITMENT DETAILS</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <table className="csz_table csz_table_blue new_graduate_table">
                        <thead>
                            <tr colSpan="1">
                                <th>募集職種</th>
                                <td>システムエンジニア</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>応募資格</th>
                                <td>2025年3月に大学院・大学・専門学校を卒業見込みの方</td>
                            </tr>
                            <tr>
                                <th>勤務地</th>
                                <td>名古屋市内及び近郊（東京支社勤務も可能）</td>
                            </tr>
                            <tr>
                                <th>募集人員</th>
                                <td>10名</td>
                            </tr>
                            <tr>
                                <th>給与</th>
                                <td>
                                    <p>
                                        214,000円・・・大学院卒<br />
                                        210,000円・・・大学卒<br />
                                        197,000円・・・専門課程(4年)卒<br />
                                        195,000円・・・専門課程(3年)卒<br />
                                        193,000円・・・専門課程(2年)卒<br />
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>手当</th>
                                <td>
                                    <p>
                                        時間外手当 (全額支給)<br />
                                        通勤手当 (全額支給)<br />
                                        住宅手当 (該当者のみ)<br />
                                        家族手当 (該当者のみ<br />
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>昇給</th>
                                <td>年1回（11月）</td>
                            </tr>
                            <tr>
                                <th>賞与</th>
                                <td>年2回 (7月・12月)</td>
                            </tr>
                            <tr>
                                <th>勤務時間</th>
                                <td>9:00 ～ 18:00 (12:00～13:00 休憩)</td>
                            </tr>
                            <tr>
                                <th>休日休暇</th>
                                <td>
                                    <p>
                                        完全週休2日制 (土・日) ・祝日<br />
                                        年間休日122日以内<br />
                                        有給休暇 (6ヶ月経過後10日付与)<br />
                                        慶弔休暇・夏季休暇・年末年始休暇<br />
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>社会保険</th>
                                <td>
                                    健康保険・厚生年金・雇用保険・労災保険
                                </td>
                            </tr>
                            <tr>
                                <th>福利厚生</th>
                                <td>福利厚生    退職金制度・育児介護休業制度・資格手当支給</td>
                            </tr>
                            <tr>
                                <th>応募方法</th>
                                <td>学校推薦または自由応募</td>
                            </tr>
                            <tr>
                                <th>提出書類</th>
                                <td>
                                    <p>
                                        履歴書、成績証明書、卒業見込証明書<br />
                                       ※個人情報につきましては当社の採用活動以外での利用は致しません
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th>選考方法</th>
                                <td>書類選考、適性検査、筆記試験、一次面接、最終面接</td>
                            </tr>
                            <tr>
                                <th>問い合せ先</th>
                                <td>
                                    <p>
                                        TEL:　052-433-7796<br />
                                        jinjinal@nalsoft.co.jp<br />
                                        採用担当：経営業務部　採用担当<br />
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="entry_section">
                    <div className="entry_content">
                        <h1 className="entry_content_header">エントリーはこちら！</h1>
                        <a className="entry_content_button" href="/recruit-form">応募フォーム</a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default HeadQuarterGraduate;